export const Pages = {
  size: 10,
  small: 10,
  debounceTime:300,
  distance: 2,
  throttle: 10,
  student_id_length: 7,
};
